/**
 * About page hero — constellation network (three-brand matrix)
 */
(function () {
  'use strict';

  function initAboutHero(root) {
    if (root.dataset.esCanvasInit === '1') return;
    root.dataset.esCanvasInit = '1';

    var canvas = root.querySelector('[data-about-hero-canvas]');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0;
    var h = 0;
    var layState = { lastW: 0, lastH: 0 };
    var stars = [];
    var hubs = [];
    var links = [];
    var pulses = [];
    var rafId = null;
    var running = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var ORANGE = '#ff6128';
    var GOLD = '#ffb647';

    function rand(a, b) {
      return a + Math.random() * (b - a);
    }

    function buildStars() {
      stars = [];
      var n = Math.max(80, Math.floor((w * h) / 8000));
      for (var i = 0; i < n; i++) {
        stars.push({
          x: Math.random() * w,
          y: Math.random() * h,
          r: Math.random() * 1.4 + 0.3,
          tw: rand(0, Math.PI * 2),
          sp: rand(0.5, 2)
        });
      }
    }

    function buildHubs() {
      hubs = [
        { x: w * 0.22, y: h * 0.58, label: 'supplier', color: ORANGE, r: 28 },
        { x: w * 0.5, y: h * 0.32, label: 'dtc', color: GOLD, r: 32 },
        { x: w * 0.78, y: h * 0.55, label: 'digi', color: '#7ec8f0', r: 26 }
      ];
      links = [
        [0, 1],
        [1, 2],
        [0, 2]
      ];
      pulses = links.map(function () {
        return { t: rand(0, 1), speed: rand(0.06, 0.12) };
      });
    }

    function resize() {
      var L = window.EastSupplierCanvasLayout;
      if (L) {
        var m = L.measure(canvas, root, { minW: 320, minH: 280, state: layState });
        w = m.w;
        h = m.h;
        dpr = m.dpr;
        L.applyBitmap(canvas, ctx, w, h, dpr);
      } else {
        var rect = (canvas.parentElement || root).getBoundingClientRect();
        w = Math.max(320, rect.width);
        h = Math.max(280, rect.height);
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        if (canvas.style) {
          canvas.style.width = '';
          canvas.style.height = '';
        }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      buildStars();
      buildHubs();
    }

    function drawBackground() {
      var g = ctx.createLinearGradient(0, 0, w * 0.5, h);
      g.addColorStop(0, '#060e18');
      g.addColorStop(0.45, '#0c1f2e');
      g.addColorStop(1, '#122a3a');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      var rg = ctx.createRadialGradient(w * 0.5, h * 0.4, 0, w * 0.5, h * 0.45, w * 0.55);
      rg.addColorStop(0, 'rgba(255, 97, 40, 0.12)');
      rg.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = rg;
      ctx.fillRect(0, 0, w, h);
    }

    function drawStars(t) {
      stars.forEach(function (s) {
        var a = reducedMotion ? 0.6 : 0.35 + 0.45 * Math.sin(t * s.sp + s.tw);
        ctx.globalAlpha = a;
        ctx.fillStyle = '#fff';
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.globalAlpha = 1;
    }

    function drawNetwork(t) {
      links.forEach(function (pair, i) {
        var a = hubs[pair[0]];
        var b = hubs[pair[1]];
        ctx.save();
        ctx.strokeStyle = 'rgba(126, 200, 240, 0.2)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        ctx.stroke();
        ctx.restore();

        var p = pulses[i];
        if (!reducedMotion) p.t += p.speed * 0.01;
        if (p.t > 1) p.t = 0;
        var px = a.x + (b.x - a.x) * p.t;
        var py = a.y + (b.y - a.y) * p.t;

        ctx.save();
        ctx.globalAlpha = 0.85;
        ctx.fillStyle = ORANGE;
        ctx.beginPath();
        ctx.arc(px, py, 3, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      });

      hubs.forEach(function (hub, idx) {
        var pulse = reducedMotion ? 0.8 : 0.65 + 0.25 * Math.sin(t * 1.5 + idx);

        ctx.save();
        ctx.globalAlpha = pulse * 0.35;
        var grd = ctx.createRadialGradient(hub.x, hub.y, 0, hub.x, hub.y, hub.r * 2);
        grd.addColorStop(0, hub.color);
        grd.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = grd;
        ctx.beginPath();
        ctx.arc(hub.x, hub.y, hub.r * 2, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();

        ctx.save();
        ctx.globalAlpha = pulse;
        ctx.strokeStyle = hub.color;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(hub.x, hub.y, hub.r, 0, Math.PI * 2);
        ctx.stroke();
        ctx.fillStyle = 'rgba(255,255,255,0.95)';
        ctx.beginPath();
        ctx.arc(hub.x, hub.y, hub.r * 0.35, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      });
    }

    function frame(ts) {
      if (!running) return;
      var expectedW = Math.max(1, Math.floor(w * dpr));
      if (canvas.width < expectedW * 0.5 || canvas.height < Math.max(1, Math.floor(h * dpr)) * 0.5) {
        resize();
      }
      var t = ts * 0.001;
      ctx.clearRect(0, 0, w, h);
      drawBackground();
      drawStars(t);
      drawNetwork(t);
      rafId = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      resize();
      running = true;
      rafId = requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    resize();
    window.addEventListener('resize', resize);

    if (typeof ResizeObserver !== 'undefined' && canvas.parentElement) {
      new ResizeObserver(function () {
        resize();
      }).observe(canvas.parentElement);
    }

    requestAnimationFrame(function () {
      resize();
    });

    start();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            resize();
            start();
          } else stop();
        });
      }).observe(root);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else {
        resize();
        var br = root.getBoundingClientRect();
        if (br.bottom > 0 && br.top < window.innerHeight) start();
      }
    });

    window.addEventListener('pageshow', function () {
      resize();
      start();
    });
  }

  function boot() {
    document.querySelectorAll('[data-about-hero]').forEach(initAboutHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
